module.exports = require('../../module.compiled').vendored[
  'contexts'
].ServerInsertedMetadata
